import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetPromotionsResponse,
  PromotionFilterType,
  PromotionType,
} from "../../../interfaces/promotionType";
import axiosTeethTab from "../../../services/apiCall";

type PromotionApiInterface = {
  getPromotions: (
    filter: PromotionFilterType,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetPromotionsResponse>>;
  savePromotion: (
    promotion: PromotionType,
  ) => Promise<ApiResponse<PromotionType>>;
  getPromotionById: (id: string) => Promise<ApiResponse<PromotionType>>;
  enable: (id: string) => Promise<ApiResponse<PromotionType>>;
  disable: (id: string) => Promise<ApiResponse<PromotionType>>;
};

export const promotionApi: PromotionApiInterface = {
  getPromotions: async (filter, pagination) => {
    return await axiosTeethTab.get("promotions", {
      params: { filter, pagination },
    });
  },
  savePromotion: async (promotion) => {
    const endpoint = promotion._id
      ? `promotions/${promotion._id}`
      : "promotions";
    return await axiosTeethTab.post<PromotionType>(endpoint, promotion);
  },
  getPromotionById: async (id: string) => {
    return await axiosTeethTab.get<PromotionType>(`promotions/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<PromotionType>(`promotions/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<PromotionType>(`promotions/${id}/disable`);
  },
};
